<template>
  <div class="container">
    <loading-spinner></loading-spinner>
  </div>
</template>

<script>
import Vue from 'vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import {
  mapGetters
} from 'vuex'

export default {
  name: 'Landing',
  components: {
    LoadingSpinner
  },
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters(['getContentLoaded', 'getViews', 'getHasFavorites'])
  },
  mounted () {
    if (this.getContentLoaded) {
      if (this.getHasFavorites) {
        this.$router.replace({ path: '/my-favorites' })
      } else if (this.getViews && this.getViews.length > 0 && this.getViews[0]) {
        this.$router.replace({ path: '/view/' + Vue.filter('formatRouteName')(this.getViews[0].title) })
      } else {
        this.$router.replace({ path: '/all' })
      }
    }
  },
  methods: {

  }
}
</script>
<style scoped>

</style>
